// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__ctEjj","main":"Layout_main__0d2yy"};